import { Stack } from '@mui/material'
import { CarrierVisitDescriptionField } from '@planning/components/carrier-visit-planning/CarrierVisitDescriptionField'
import { IVesselPlanning } from '@planning/components/carrier-visit-planning/CarrierVisitPlanning.model'
import { formatTime } from '@planning/utils'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'

interface Props {
  visit: IVesselPlanning
}
export const VesselVisitCardDescription = observer(({ visit }: Props) => {
  const { t } = useTranslate()

  return (
    <Stack>
      <Stack flexDirection='row' columnGap={1} flexWrap='wrap'>
        <CarrierVisitDescriptionField
          label={t(visit.etaLabel ?? 'eta')}
          value={formatTime(visit?.eta)}
        />

        <CarrierVisitDescriptionField
          label={t(visit.etbLabel ?? 'etb')}
          value={formatTime(visit?.etb)}
        />

        <CarrierVisitDescriptionField
          label={t(visit.etdLabel ?? 'etd')}
          value={formatTime(visit?.etd)}
        />
      </Stack>
      <CarrierVisitDescriptionField
        label={t('draftInOut', 'Draft in/out')}
        value={`${visit?.draftIn}m/${visit?.draftOut}m`}
      />
      <Stack flexDirection='row' gap={1}>
        <CarrierVisitDescriptionField
          label={t('dischargeLoadRestow', 'D/L/R')}
          value={`${visit?.dischargeEstimate}/${visit?.loadEstimate}/${visit?.restowEstimate}`}
        />
      </Stack>
    </Stack>
  )
})
